import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";

import RequestConfig from "../../mini_components/RequestConfig";
import { cn } from "../../utils/utils";
import { selectCustomStyles } from "../../lib/constants";

const SelectApplication = (props) => {
  const { control, label, name, className, errors, disabled } = props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      const response = await RequestConfig.get(`/applications/`);
      const fetchedOptions = response.data.results.map((item) => ({
        value: item.en_name, // This is what you want to store/send
        label: item.name,    // This is what you want to show in Persian
      }));
      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  return (
    <div
      className={cn("col-span-2 xl:col-span-1 flex flex-col gap-2", className)}
    >
      <label htmlFor={name} className="text-[14px] md:text-[16px]">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          const selected = options.find((option) => option.value === value);

          return (
            <Select
              styles={selectCustomStyles}
              options={options}
              isDisabled={disabled}
              selected={selected || null}
              onChange={(selectedOption) => {
                
                onChange(selectedOption ? selectedOption : null);
              }}
              placeholder="جستجو..."
              isClearable={true}
              noOptionsMessage={() => "موردی یافت نشد ..."}
            />
          );
        }}
      />
      {errors?.message && (
        <div className="text-red-500 text-sm">{errors?.message}</div>
      )}
    </div>
  );
};

export default SelectApplication;
